@if (isLoading) {
  <div>
    <ngx-skeleton-loader
      [count]="1"
      [theme]="{
        'margin-bottom': 0,
        height: '56px',
        width: '100%',
      }"></ngx-skeleton-loader>
  </div>
}

@if (isError) {
  <div class="h-full w-full">
    <app-something-went-wrong
      [showPicture]="false"
      (retryEmitter)="ngOnInit()"></app-something-went-wrong>
  </div>
}

@if (!isLoading && !isError) {
  <div class="drawer-content-screen">
    @if (isDrawer) {
      <div class="drawer-content-screen__title">
        {{ (header ? header : 'addTags') | translate }}
      </div>
    }

    <form class="note mb-auto flex-none gap-2 md:flex" [formGroup]="form">
      <mat-form-field class="w-full">
        <mat-label>{{ (label ? label : 'newTag') | translate }}</mat-label>
        <input
          #input
          style="height: 24px"
          type="text"
          matInput
          formControlName="tag"
          [matAutocomplete]="auto"
          (focus)="onInputFocus()" />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selectedTag($event)">
          @for (option of filteredOptions | async; track option.tagId) {
            <mat-option [value]="option">
              <mat-icon
                class="small"
                [ngStyle]="{ color: option?.color ?? TAGS_COLORS.grey }">
                label
              </mat-icon>
              {{ option.tag }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <app-tag-color-select class="w-full" formControlName="color" />
      @if (isLoadingAddTag) {
        <mat-spinner class="mr-2 self-center" diameter="40"></mat-spinner>
      } @else {
        <button
          [disabled]="isDisabledAddTag()"
          mat-icon-button
          class="mt-4"
          (click)="addNewTag()">
          <mat-icon [class.blue]="!isDisabledAddTag()">add_circle</mat-icon>
        </button>
      }
    </form>
    @if (thisTags.length) {
      <div class="notes flex flex-col gap-4">
        @for (tag of thisTags; track tag.tag) {
          <app-tag-component
            [tag]="tag"
            (deleteTag)="deleteTag($event)"
            [withDelete]="true" />
        }
      </div>
    }
    <div class="flex w-full justify-end">
      <button
        mat-flat-button
        [disabled]="isSavingTags"
        color="primary"
        (click)="handleSave()">
        <app-loading-button
          text="{{ (buttonLabel ? buttonLabel : 'save') | translate }}"
          [loading]="isSavingTags"></app-loading-button>
      </button>
    </div>
  </div>
}
